import { render, staticRenderFns } from "./video-toast.vue?vue&type=template&id=2fdc644e&scoped=true"
import script from "./video-toast.vue?vue&type=script&lang=js"
export * from "./video-toast.vue?vue&type=script&lang=js"
import style0 from "./video-toast.vue?vue&type=style&index=0&id=2fdc644e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdc644e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fdc644e')) {
      api.createRecord('2fdc644e', component.options)
    } else {
      api.reload('2fdc644e', component.options)
    }
    module.hot.accept("./video-toast.vue?vue&type=template&id=2fdc644e&scoped=true", function () {
      api.rerender('2fdc644e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tai-xiu/video-toast.vue"
export default component.exports